import React from "react";
import { MessageCircle } from "lucide-react";

// "Mochi this month" — warm engagement card. Shows chat count + days active
// this calendar month. Hidden when there's no data yet so a brand-new user
// doesn't see a sad zero.
export default function MochiThisMonthCard({ monthly }) {
    if (!monthly || !(monthly.chats_this_month > 0)) return null;
    const c = monthly.chats_this_month;
    const d = monthly.days_chatted_this_month;
    const phrase = c === 1
        ? `we chatted once this ${monthly.month_label.split(" ")[0]} 🍡 looking forward to more.`
        : d === 1
        ? `${c} chats with me ${monthly.month_label} 🍡 cozy.`
        : c >= 30
        ? `${c} chats across ${d} days this ${monthly.month_label.split(" ")[0]} 🍡 we're a duo.`
        : `${c} chats with me across ${d} days this ${monthly.month_label.split(" ")[0]} 🍡`;
    return (
        <div
            className="mb-5 rounded-clay bg-gradient-to-br from-sage/40 to-mustard-soft/30 p-4 flex items-start gap-3"
            data-testid="mochi-this-month"
        >
            <span
                className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-cream text-terracotta"
                aria-hidden="true"
            >
                <MessageCircle size={18} />
            </span>
            <div className="flex-1 min-w-0">
                <p className="font-display text-xs uppercase tracking-widest text-warm-500">
                    Mochi · {monthly.month_label}
                </p>
                <p
                    className="font-display text-base text-warm-900 leading-snug mt-0.5"
                    data-testid="mochi-this-month-headline"
                >
                    {phrase}
                </p>
            </div>
        </div>
    );
}
